package com.example.mystybag.permissionsUtils.logic

import com.example.mystybag.common.resources.SR
import com.example.mystybag.core.logic.base.DialogConfig
import com.example.mystybag.core.expected.sharedString

/** DIALOGS */

class DialogNavigatorPermissionSettings(
    override val title      : String,
    override val closable   : Boolean = true,
    override val message    : String = sharedString(SR.strings.permission_not_allowed)
): DialogConfig() {
    override val positiveTitle  = sharedString(SR.strings.settings)
    override val negativeTitle  = sharedString(SR.strings.cancel)
}